export enum MODAL_BANNER_MESSAGE_TYPE {
  SUCCESS,
  CAUTION,
  FAIL,
  FAIL_400,
}

export enum MODAL_BANNER_TYPE {
  //SUCCESS
  API_SUCCESS,

  //CAUTION
  NO_DATA_AVAILABLE,

  //COMMON ERRORS
  API_UNAUTHORIZED,
  API_ERROR,
  API_400_ERROR,
}

const SUCCESS_BANNERS = {
  [MODAL_BANNER_TYPE.API_SUCCESS]: {
    type: MODAL_BANNER_MESSAGE_TYPE.SUCCESS,
    text: $localize`Operation Successful`,
  },
};

const CAUTION_BANNERS = {
  [MODAL_BANNER_TYPE.NO_DATA_AVAILABLE]: {
    type: MODAL_BANNER_MESSAGE_TYPE.CAUTION,
    text: $localize`No Data Available`,
  },
};

const COMMON_ERRORS = {
  [MODAL_BANNER_TYPE.API_ERROR]: {
    type: MODAL_BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Operation Unsuccessful`,
  },
  [MODAL_BANNER_TYPE.API_400_ERROR]: {
    type: MODAL_BANNER_MESSAGE_TYPE.FAIL_400,
    text: $localize`Error - %s`,
  },
  [MODAL_BANNER_TYPE.API_UNAUTHORIZED]: {
    type: MODAL_BANNER_MESSAGE_TYPE.FAIL,
    text: $localize`Error - Not Authorized`,
  },
};

export const MODAL_BANNER = {
  ...SUCCESS_BANNERS,
  ...CAUTION_BANNERS,
  ...COMMON_ERRORS,
};
